import React from "react"
import DeleteFilter from "../../../../assets/iconos/close.svg";
import Helpers, { dateFormat, number_format, month_result_items } from "../../../../config/Helpers";
import axios from "axios";
import InfiniteScroll from 'react-infinite-scroll-component';
import { _row_reservation, api, row_detail, row_panel } from "../widgets/Reserves";

class Reserves extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            months              : "",
            general_result      : "",
            month_result        : Object.assign({}, month_result_items()),
            month_result_aux    : {},
            month_keys          : {},
            totals : {
                adr_ai      : 0,
                adr_ep      : 0,
                rn       : 0,
                revenue  : 0
            },
            month_list : {
                status : "inactive",
                key    : "ENE"
            }
        }
        this.setDefaultValues = this.setDefaultValues.bind(this);
        this.loadItems        = this.loadItems.bind(this);
    }

    setDefaultValues(){
        this.setState({
            months              : "",
            general_result      : "",
            month_result        : {
                ENE : {
                    items : [],
                    hasMore : true,
                    page:0,
                    total:0,
                    load:0
                },
                FEB : {
                    items : [],
                    hasMore : true,
                    page:0,
                    total:0,
                    load:0
                },
                MAR : {
                    items : [],
                    hasMore : true,
                    page:0,
                    total:0,
                    load:0
                },
                ABR : {
                    items : [],
                    hasMore : true,
                    page:0,
                    total:0,
                    load:0
                },
                MAY : {
                    items : [],
                    hasMore : true,
                    page:0,
                    total:0,
                    load:0
                },
                JUN : {
                    items : [],
                    hasMore : true,
                    page:0,
                    total:0,
                    load:0
                },
                JUL : {
                    items : [],
                    hasMore : true,
                    page:0,
                    total:0,
                    load:0
                },
                AGO : {
                    items : [],
                    hasMore : true,
                    page:0,
                    total:0,
                    load:0
                },
                SEP : {
                    items : [],
                    hasMore : true,
                    page:0,
                    total:0,
                    load:0
                },
                OCT : {
                    items : [],
                    hasMore : true,
                    page:0,
                    total:0,
                    load:0
                },
                NOV : {
                    items : [],
                    hasMore : true,
                    page:0,
                    total:0,
                    load:0
                },
                DIC : {
                    items : [],
                    hasMore : true,
                    page:0,
                    total:0,
                    load:0
                },
            },
            month_result_aux    : {},
            month_keys          : {},
            totals : {
                adr_ai      : 0,
                adr_ep      : 0,
                rn       : 0,
                revenue  : 0
            },
            month_list : {
                status : "inactive",
                key    : "ENE"
            }
        })
    }
    loadItems(){
        const $self = this;
        $self.state.month_result[$self.state.month_list.key].hasMore
        if($self.state.month_result[$self.state.month_list.key].hasMore){
            axios.get(api.baseUrl, {
                //Filtro especial con parametro de paginador 
                params: $self.props.currentFilters({ 
                    page : $self.state.month_result[$self.state.month_list.key].page, 
                    month_key : $self.state.month_list.key
                }) 
            }).then(result => { 
                let list_reservations = result.data.list_reservations;
                const hasMore = result.data.has_more;
                const total = result.data.total;
                const new_reserves = Object.keys(list_reservations).map((key_r, index_aux) => 
                    _row_reservation(key_r, list_reservations[key_r], $self.state.month_keys[$self.state.month_list.key], index_aux)
                );

                let month_result = Object.assign({}, $self.state.month_result);
                let _reserves =  $self.state.month_result[$self.state.month_list.key].items.concat(new_reserves);
                month_result[$self.state.month_list.key].items = _reserves;
                month_result[$self.state.month_list.key].page += 1;
                month_result[$self.state.month_list.key].hasMore = hasMore
                month_result[$self.state.month_list.key].total = total
                
                $self.setState({
                    month_result
                })
            }).catch(error => { throw error; })
        }
    }
    
    setStateMonth(key){
        let month_keys_aux = this.state.month_keys;
        
        const state_key = month_keys_aux[key].state === "inactive" ? "active" : "inactive"
        month_keys_aux[key].state = state_key;
        
        this.setState({
            month_list : {
                status : state_key,
                key : key
            },
            month_keys : month_keys_aux
        }, function(){
            this.loadItems()
        })
    }

    componentWillReceiveProps(props){
        
        const isset = Object.keys(props.response_request).length > 0;
        let $self = this;
        let month_keys, totals;
        if (isset){
            totals  = props.response_request["data_reserves_month"]["totals"]
            month_keys  = props.response_request["data_reserves_month"]["result"]
            console.log("Received",Object.assign({}, month_result_items()))
            $self.setState({
                month_result : Object.assign({}, month_result_items()),
                month_keys : month_keys,
                totals : {
                    adr_ai   : totals["adr_ai"],
                    adr_ep   : totals["adr_ep"],
                    rn       : totals["rn"],
                    revenue  : totals["revenue"]
                }
            });
        }
    }

    render() {
        let $self = this, 
        months, 
        general_result,
        month_totals = [];

        months = Object.keys($self.state.month_keys).map((key, index) => {
            const props = {
                key : `list-months-reserve- ${index}`,
                className : `column-grid ${(index % 2 ? "row-c " : "")} ${$self.state.month_keys[key].state}`
            }
            return (
                <div {...props}>
                    <span className="title day" children={ key } />
                    { /*<span onClick={this.setStateMonth.bind(this, key)} className={ "filter-row " + $self.state.month_keys[key].state } /> */ }
                </div>
            )
        });

        general_result = Object.keys($self.state.month_keys).map((key, index) => {

            const list_reservations = $self.state.month_keys[key].list_reservations;
            
            month_totals[key] = (
                <div className="column-grid totals">
                    <div className={`${row_detail} no`} 
                        children={ `Reservas ${$self.state.month_result[$self.state.month_list.key].items.length} / ${$self.state.month_result[$self.state.month_list.key].total}`}/>
                    <div className={`${row_detail} checkin`}/>
                    <div className={`${row_detail} checkout`}/>
                    <div className={`${row_detail} troom`}/>
                    <div className={`${row_detail} agency`}/>
                    <div className={`${row_detail} plan`}/>
                    <div className={`${row_detail} adr`} />
                    <div className={`${row_detail} nights`} children={ number_format($self.state.month_keys[key].room_nights) } />
                    <div className={`${row_detail} revenue`} children={`$${ $self.state.month_keys[key].revenue} `} />
                </div>
            );

            return (
                <div className={"column-grid " + (index % 2 ? "row-c " : "")}>
                    <div className={`${row_panel} reserves`} children={number_format($self.state.month_keys[key].num_reservations)} />
                    <div className={`${row_panel} ai`} children={number_format($self.state.month_keys[key].ai_reservations)} />
                    <div className={`${row_panel} ep`} children={number_format($self.state.month_keys[key].ep_reservations)} />
                    <div className={`${row_panel} adr`} children={`$${$self.state.month_keys[key].ai_adr}`} />
                    <div className={`${row_panel} adr`} children={`$${$self.state.month_keys[key].ep_adr}`} />
                    <div className={`${row_panel} rn`} children={number_format($self.state.month_keys[key].room_nights)} />
                    <div className={`${row_panel} revenue`} children={`$${$self.state.month_keys[key].revenue}`} />
                </div>
            );
        })

        return ( 
            <section>
                <div className={"datagrid-widget list-month " + this.state.month_list.status}>
                    <div className="container-fluid">
                        <div className="row header-widget">
                            <div className="col-md-12 options-widget">
                                <span className="title year" children={this.props.current_year} />
                            </div>
                        </div>
                        <div className="current-values">
                            <div className="row">
                                <div className="col-md-12 head-current">
                                    <span className="row-grid" children={`MES`} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 datagrid-list">
                                    { months }
                                    <div className={"column-grid totals"}>
                                        <div className="row-grid" children={`TOTALES`} />
                                    </div>
                                </div>
                            </div>
                        </div>   
                    </div>
                </div>
                <div className={"datagrid-widget list-result-reserves "}>
                    <div className="container-fluid">
                        <div className="row header-widget">
                            <div className="col-md-12 options-widget">
                                <span className="title" children={`RESERVACIONES DESGLOSADAS (TARIFAS POR NOCHE) LLEGADAS`} />
                                <span className="opt remove-widget hide">
                                    <img src={DeleteFilter} />
                                </span>
                            </div>
                        </div>
                        <div className={"current-values list-general " + (this.state.month_list.status === "active" ? "hide" : "")}>
                            <div className="row">
                                <div className="col-md-12 head-current">
                                    <span className={`${row_panel} reserves`} children={`RESERVACIONES`} />
                                    <span className={`${row_panel} ai`} children={`AI`} />
                                    <span className={`${row_panel} ep`} children={`EP`} />
                                    <span className={`${row_panel} adr`} children={`TARIFA PROMEDIO (AI)`} />
                                    <span className={`${row_panel} adr`} children={`TARIFA PROMEDIO (EP)`} />
                                    <span className={`${row_panel} rn`} children={`CUARTOS NOCHE`} />
                                    <span className={`${row_panel} revenue`} children={`INGRESO`} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 datagrid-list">
                                    { general_result }
                                    <div className={"column-grid totals"}>
                                    <span className={`${row_panel} reserves`}></span>
                                    <span className={`${row_panel} ai`}></span>
                                    <span className={`${row_panel} ep`}></span>
                                    <span className={`${row_panel} adr`}>${number_format(this.state.totals.adr_ai)}</span>
                                    <span className={`${row_panel} adr`}>${number_format(this.state.totals.adr_ep)}</span>
                                    <span className={`${row_panel} rn`}>{number_format(this.state.totals.rn)}</span>
                                    <span className={`${row_panel} revenue`}>${number_format(this.state.totals.revenue, 2)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>   

                        <div className={"current-values list-details " + (this.state.month_list.status === "inactive" ? "hide" : "")}>
                            <div className="row">
                                <div className="col-md-12 head-current">
                                    <span className={`${row_detail} no`} children={`CLAVE`}/>
                                    <span className={`${row_detail} checkin`} children={`LLEGADA`}/>
                                    <span className={`${row_detail} checkout`} children={`SALIDA`}/>
                                    <span className={`${row_detail} troom`} children={`T. HAB`}/>
                                    <span className={`${row_detail} agency`} children={`AGENCIA`}/>
                                    <span className={`${row_detail} plan`} children={`PLAN`}/>
                                    <span className={`${row_detail} adr`} children={`TAR. X NOCHE`}/>
                                    <span className={`${row_detail} nights`} children={`NOCHES`}/>
                                    <span className={`${row_detail} revenue`} children={`INGRESO`}/>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 datagrid-list details">
                                    <InfiniteScroll
                                        style={
                                            { overflow : "auto" }
                                        }
                                        next={this.loadItems}
                                        dataLength={ Object.keys(this.state.month_result).length > 0 ? 
                                            Object.keys(this.state.month_result[this.state.month_list.key].items).length : 
                                            0}
                                        height={360}
                                        hasMore={this.state.month_result[$self.state.month_list.key].hasMore}
                                        loader={<h4>Loading...</h4>}>
                                        { 
                                           // Object.keys(this.state.month_result[this.state.month_list.key]).length > 0 ? "hola" : "holas"
                                           Object.keys(this.state.month_result).length > 0 ? 
                                            this.state.month_result[this.state.month_list.key].items : 
                                            ""
                                        }
                                    </InfiniteScroll>
                                </div>
                            </div>
                        </div>
                        <div className={"current-values " + (this.state.month_list.status === "inactive" ? "hide" : "")}>
                            <div className="row">
                                <div className="col-md-12 datagrid-list">
                                    { month_totals[this.state.month_list.key] }
                                </div>
                            </div>
                        </div>    
                    </div>
                </div>
            </section>
        )
    }
}

export default Reserves



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/reservations/views/Reserves.js